import { createContext } from 'react'

interface VerticalCatalogProps {
  scrollToItem: (itemNumber: number) => void
}

export const VerticalCatalogContext = createContext<VerticalCatalogProps | undefined>(undefined)
